import React from 'react';

import axios from 'axios'
import { Table, Input, Button,Collapse,Popover,Popconfirm,message,Spin } from 'antd';

import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,DeleteOutlined,FundViewOutlined,LoadingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import * as serverconfig from '../serverconn'
import CurrencyFormat from 'react-currency-format';

import FDAView from './AccountCreateFDAView'

var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

function callback(key) {
  console.log(key);
}

var sacco= ''
var token= ''

class FixedDepositDetails extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    fixeddepositstatementitems: [],
    datarequested:true,
    fixeddepositsschdulesitems: [],

  };

  componentDidMount(){
    const depositid=this.props.match.params.depositid;


    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
    }else{
       sacco= ''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(serverconfig.backendserverurl+`/api/fixeddepositsschedules/?sacco=${sacco}&fixed_deposit=${depositid}`)
    .then(res => {
        this.setState({
          fixeddepositsschdulesitems:res.data
        })
    })

    axios.get(serverconfig.backendserverurl+`/api/fixeddepositsstatement/?sacco=${sacco}&fixed_deposit=${depositid}`)
    .then(res => {
        this.setState({
          fixeddepositstatementitems:res.data
        })

        this.setState({datarequested:false})
    })
}

 

getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={node => {
          this.searchInput = node;
        }}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select());
    }
  },
  render: text =>
    this.state.searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    ),
});

handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  this.setState({
    searchText: selectedKeys[0],
    searchedColumn: dataIndex,
  });
};

handleReset = clearFilters => {
  clearFilters();
  this.setState({ searchText: '' });
};

  render() {
    const schdulescolumns = [
      {
        title: 'Repayment No',
        dataIndex: 'repayment_number',
        key: 'id',
      },
      {
        title: 'Date',
        dataIndex: 'date',
        key: 'id',
      },
      {
        title: 'Interest To be received ',
        dataIndex: 'interest_tobe_received',
        key: 'id',
        render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
      },
      {
        title: 'New Fixed Amount',
        dataIndex: 'newfixedamount',
        key: 'id',
        render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
      },

      {
        title: 'Cleared',
        dataIndex: 'alreadyCleared',
        key: 'id',
        render:text=><p>{text===true?'yes':'no'}</p>
      }, 
        

    ];


    const statementcolumns = [
      {
        title: 'Date',
        dataIndex: 'date',
        key: 'id',
      },
      {
        title: 'Interest Received',
        dataIndex: 'interestreceived',
        key: 'id',
        render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
      },
      {
        title: 'New Amount',
        dataIndex: 'newfixedamount',
        key: 'id',
        render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
      },
      {
        title: 'Comment',
        dataIndex: 'comments',
        key: 'id',
      }
      
    ];

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return(
        <div>
            <Collapse defaultActiveKey={['1']} onChange={this.callback}>
            <Panel header="FIXED DEPOSIT INTREST SCHEDULE " key="1">
            <Table 
            columns={schdulescolumns} 
            scroll={{ x: 1000 }}
            pagination={{showQuickJumper:true,showSizeChanger:true }}
            dataSource={this.state.fixeddepositsschdulesitems} 
            bordered/>
            </Panel>
            </Collapse>
         
        </div>
    )

    }

  }
}

export default FixedDepositDetails; 
